import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { isPublicPath } from '/imports/utils';
import { useUser } from '/imports/hooks';
import { setSetting } from '/imports/api/users';

export const RouteListener = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const user = useUser();
  useEffect(() => {
    // if (publicPaths.includes(pathname)) {
    //   return;
    // }
    // if (['/tcg'].includes(pathname)) {
    //   return;
    // }
    // if (pathname.endsWith('/logout')) {
    //   return;
    // }
    // const clientPath = `${location.pathname}${location.search}`;
    // user?.settings?.clientPath !== clientPath && setSetting.call({ key: 'clientPath', value: clientPath });
  }, [location]);
  useEffect(() => {
    window.addEventListener('beforeunload', async () => {
      if (isPublicPath()) return;
      if (['/tcg'].includes(pathname)) return;
      if (pathname.endsWith('/logout')) return;
      const clientPath = `${location.pathname}${location.search}`;
      user?.settings?.clientPath !== clientPath && await setSetting.call({ key: 'clientPath', value: clientPath });
    });
  }, []);
  return null;
};